export default {
  General: {
    Home: 'Home',
    Alpacas: 'Alpacas',
    Adopt: 'Adopt',
    Stake: 'Stake',
    Breeding: 'Breeding',
    Farm: 'Farm',
    Guide: 'Guide',
    AlpacaCity: 'Alpaca City',
    Breed: 'Breed',
    Alpapa: 'Alpapa',
    Almama: 'Almama',
    APY: 'APY',
    Confirm: 'Confirm',
    Energy: 'Energy',
    Claim: 'Claim',
    Deposit: 'Deposit',
    Withdraw: 'Withdraw',
    GN: 'GN',
    Birthday: 'Birthday',
    Owner: 'Owner',
    Traits: 'Traits',
    ConnectWalletFirst: 'Please connect wallet first',
    Gen: 'Gen',
    Parents: 'Parents',
    Hatch: 'Hatch',
    Transfer: 'Transfer',
    Children: 'Children',
    MyAlpacas: 'My Alpacas',
    OtherAlpacas: 'Other Alpacas',
    Approve: 'Approve',
    Approving: 'Approving...',
    Cancel: 'Cancel',
    Farms: 'Farms',
    Substitute: 'Substitute',
    Recall: 'Recall',
    Max: 'Max',
    Participate: 'Participate',
    Farming: 'Farming...',
    Squad: 'Squad',
    Available: 'Available',
    ID: 'ID',
    Close: 'Close',
    Dismiss: 'Dismiss',
    ConnectWallet: 'Connect Wallet',
    Choose: 'Choose',
    Assign: 'Assign',
    Players: 'Players',
    Wool: 'Wool',
    WOOL: 'WOOL',
    Recycle: 'Recycle',
    Exchange: 'Exchange',
    Save: 'Save',
    Referral: 'Referral',
    StakeIn: 'Stake In',
    StakeOut: 'Stake Out',
    Staked: 'Staked',
    Earned: 'Earned',
    Boost: 'Boost',
    Feed: 'Feed',
    Price: 'Price',
    HelpCenter: 'Help Center',
    ALPABridge: 'ALPA Cross-Blockchain Bridge',
    WrongNet: 'Wrong Network',
    Christmas: 'Christmas',
    MyScarves: 'My Scarves',
    InUse: 'In Use',
    Accessories: 'Accessories',
    TakeOff: 'Take Off',
    Scarves: 'Scarves',
    Community: 'Community',
    Market: 'Market',
    Bank: 'Bank',
    Game: 'Game',
  },
  Home: {
    Welcome: 'Welcome to Alpaca City',
    View: 'View My Alpaca',
    Adopt: 'Adopt an Alpaca',
    BurnedFees: 'ALPA burned through fees',
    Lauching:
      'Alpaca City is lauching on Binance Smart Chain on Dec. 3rd, 2pm UTC',
    FreeClaim: `5000 Gen 0 Alpaca to be claimed for <span style="font-weight: 500">FREE</span>. Check how to join <a href="https://in.alpaca.city/bsc-announcement" target="_blank">here</a>`,
    FreeClaimBtn: 'Claim FREE Alpacas and WOOL',
    ClaimGift: 'Claim FREE Christmas Gift Starting on Dec 21st 3am UTC',
    FreeClaimChristmas: 'Claim FREE Christmas NFT Gift',
    StartToFarm: 'Start to farm with scarf',
	GameTitle: 'AlpacaVoid is coming soon',
	GameIntro: `AlpacaVoid is a 2D Web3 game. Players can plant to obtain rewards from environment and hunt to win rewards from other players. The game will enter large-scale testing in March 2022. Yes, it's coming soon!`,
	PlantingTitle: 'Planting',
	PlantingIntro: 'Playing as a farmer, using Land NFT to complete planting can get rewards from environment, where the Land NFT level will significantly affect the planting yield. As all you know, the timing of planting is critical',
	HuntingTitle: 'Hunting',
	HuntingIntro: `Playing as a hunter, using Alpaca NFT to launch an alpaca battle with other farmers. The winner will be able to take the planting rewards from the loser. Although a player with higher energy alpacas will have an advantage in the battle, the player's wisdom and strategy are often the keys to victory`,
	LandTitle: 'About Land',
	LandIntro: `The Land is where Alpacas live. They built there, planted there and even fought there to protect their homes. Land help Alpacas to achieve $APV from the universe and Alpacas transfer Land between parallel universes to obtain higher planting yields. <p> The Land NFT is the key to join the game, and there are 5 levels of Land's rarity: <span style="font-weight: 500">Common</span>, <span style="font-weight: 500">Uncommon</span>, <span style="font-weight: 500">Rare</span>, <span style="font-weight: 500">Epic</span> and <span style="font-weight: 500">Legendary</span>. High level of rarity means high yields. Also, Land has many topics: day, night and 4 seasons. Some say the most beautiful snow topic comes with the most rare Lands`,
  },
  Preview: {
    Title: 'Alpaca Photo Booth',
  },
  SelectAlpacas: {
    NoMyAlpaca: `You don't have any Alpaca :(`,
    Adopt: 'Adopt an Alpaca',
    SortBy: 'Sort by',
    NoAlpaca: 'No Alpaca found :(',
  },
  SelectBreeding: {
    NoAllow: 'Parents are not allowed to breed',
    OtherAlpacas: 'Other Alpacas',
    SelectToBreed: 'Select the {parent} to breed',
  },
  SelectFarmer: {
    SelectToFarm: 'Select an alpaca to farm',
  },
  Adopt: {
    TotalPrice: 'Total Price',
    Left: '{num} left in public sell.',
    CanAdopt: 'You can adopt {num} alpacas.',
    Preview: 'Alpaca Photo Booth',
    NotEnoughAlpacas:
      'Not enough alpacas could be adopted, please try another quantity',
    NotEnoughWool: 'Not enough balance, please try another quantity',
  },
  Breeding: {
    SelectAlpaca: 'Select an alpaca',
    TotalBreedingFees: 'Total Breeding Fees',
    BangBang: 'Bang Bang',
  },
  Stake: {
    TotalRewards: 'Total Rewards (24h)',
    TotalValueStaked: 'Total Value Staked',
    StakeIn: 'Stake In',
    StakeOut: 'Stake Out',
    Available: '{token} Available',
    Deprecated: `Staking was deprecated and all future breeding fees will be burned. Stake out to redeem your ALPA principle and ALPA rewards. With this burn model, ALPA is estimated to become deflationary within a couple months. Check out the details about why we did this`,
    Here: 'here',
  },
  Farm: {
    AlpacaFarmer: 'Alpaca Farmer',
    ChooseFarmer: 'Choose your Alpaca Farmer to boost your yield',
    TotalDeposit: 'Total deposit',
    MaxInPool: 'Max in Pool',
    MediumInPool: 'Medium in Pool',
    YourAlpacaFarmer: 'Your alpaca farmer',
    ALPAEarned: 'ALPA Earned',
    LPDeposit: 'ALPA/ETH token deposit',
    LPDepositBSC: 'ALPA/BNB LP token deposit',
    YourWallet: 'Your Wallet',
    BuyALPA: 'Buy ALPA',
    GetLPToken: 'Get ALPA/ETH LP tokens',
    GetLPTokenBSC: 'Get ALPA/BNB LP tokens',
    WithdrawLP: 'Withdraw ALPA/ETH LP Token',
    WithdrawLPBSC: 'Withdraw ALPA/BNB LP Token',
    UniswapLP: 'ALPA/ETH Uniswap LP',
    PancakeSwapLP: 'ALPA/BNB PancakeSwap LP',
    ScarfFarm: 'Scarf Farm',
    ChooseScarfFarm: 'Choose scarf to farm ALPA reward',
    PoolOutdated: 'Pool Outdated',
    Switch: `The ALPA/BNB LP farm rewards on #BSC  will be switched to the new  @PancakeSwap V2 Liquidity Pool on block 6962800 (Apr 28th 9 AM PST). Please migrate your LP tokens to V2 on @PancakeSwap.

        Alpaca LP Farm Contract on #BSC :
        0x25B0dc84b62D7e2bd4eBba0Dda6C25E3e7c0D717`,
    SwitchPool: `Both ALPA/ETH and ALPA/BNB LP farm rewards will be switched to the new Liquidity Pool at Apr 22th 0 AM PDT. Please migrate your LP tokens and Alpaca to new pool.
        New Alpaca LP Farm Contract on #ETH : 0x1b2318F32536AB44ECD9EA320eD83Af13779113a,
        New Alpaca LP Farm Contract on #BSC : 0xb843B7EF28587a2C36714339355D8578189c001E`,
  },
  AlpacaInfo: {
    ReadyToHatch: 'Ready to Hatch',
    ReadyToHatchIn: 'Ready to Hatch in',
    AlpacaNotFound: 'Alpaca not found :(',
    BreedingFees: 'Breeding Fees: {num} ALPA',
    BreedIn: 'Breed in',
    BreedFeesReset:
      'Breeding fees will reset to the basic price in 7 days after the last breeding. In 7 days every time breeding price increase x2,x4,x8,x16 multiplier.',
    HatchedBy: 'Hatched by',
    DateOfDeath: 'Date of death',
  },
  Presale: {
    TotalFundRaised: 'Total Fund Raised',
    PresaleCompleted: 'Presale Completed',
    LearnMore: 'Learn more about Alpaca City',
    Allocation: 'Alloction at {rate}ALPA/ETH',
  },
  TransactionResult: {
    View: 'View on {addr}',
    Wait: 'Waiting For Confirmation',
    Cancel: 'Transaction Cancelled',
  },
  Transfer: {
    WalletAddress: 'Wallet address',
  },
  Squad: {
    ALPAEarned: 'ALPA Earned',
    WeeklyReward: 'Estimated Weekly Rewards',
    MySquad: 'My Squad',
    SquadMemebers: '{num} Squad Members',
    TotalEnergy: '{num} Total Energy',
    AvgEnergy: '{num} Average Energy',
    PercentageReward: '{num}% of pool rewards',
    NoSquad: 'Please choose alpacas to assemble your squad!',
    AlpacaSquad: 'Alpaca Squad',
    SquadFarm: 'Squad Farm',
    RewardEarned: 'Reward Earned',
    BSCCelebrate:
      'To celebrate our BSC launch, our partners DEGO, Bounce Finance, and BurgerSwap have sponsered <b>$7000 worth of DEGO, BOT and BURGER to reward players</b> who particpated in Alpaca Squad Farm in the first week. See detailed rules <a href="https://in.alpaca.city/squad-bonus" target="_blank">here</a>.',
  },
  SelectSquad: {
    SelectAssign: 'Select Your Alpaca to Squad',
    SelectRecall: 'Select You Member to Recall',
    MaxWarning: `The alpaca squad has reached it's maximum number of members.`,
  },
  Trade: {
    TotalAlpacasRecycled: 'Total Recycled',
    MyRecycledAlpacas: 'Recycled by Me',
    MyBalance: 'My Balance',
    RecycleAlpaca: 'Recycle Alpaca',
    ExchangeAlpaca: 'Exchange Alpaca',
  },
  Recycle: {
    Choose: 'Recycle alpacas to get',
  },
  SelectRecycle: {
    SelectRecycle: 'Choose Alpacas to recycle',
    SelectedInfo:
      'Have selected <span class="text-blue">{num}</span> alpacas, <span class="text-blue">{energy}</span> Total energy To recycle can get <span class="text-blue">{wool} WOOL</span>',
  },
  AdoptCenter: {
    Left: '{num} Alpacas left',
    feesInfo:
      'This fee is to cover the minting cost when we pre-mint Alpacas into the pool.',
    canAdoptNum: 'You can exchange {num} alpaca. ',
  },
  Referral: {
    Rule:
      'Invite Your Friends and get 5% of their breeding fees! 90% of the breeding fees is will still be burned and the 5% referral commission comes from the 10% dev team allocation. Please make sure your friend save your address as referrer in order to receive comissions. Comissions will be send out every Monday at 3am UTC. ',
    MyReferrer: 'My Referrer',
    MyReferralLink: 'My Referral Link',
    MyCommission: 'My Commission',
    CommissionRate:
      'Commission rate: <span class="text-blue">5%</span> of breeding fees',
    Friends: 'Total Number of Friends',
    TotalCommissions: 'Total commissions',
    CommissionRecords: 'Commission Records',
    NoRecords: 'You don’t have any commission records',
    LearnMore: 'Learn more',
    From: 'From',
    YourReferrerAddress: 'Your Referrer Address',
    LinkCopied: 'Referral link copied!',
    CopyFailed: 'Copy failed.',
    AcceptSuccess: 'Accept Invitation Successfully',
    InvalidAddress: 'Invalid Address',
    CycleReferral: 'Forbid Cycle Referral',
    Title: 'Invite Friends and Earn ALPA',
    InvitedBy: 'You are invited by',
    AcceptInvitation: 'Accept Invitation',
  },
  WoolStake: {
    ManageStake: 'Manage Stake',
    WinWool: 'Stake ALPA to Win WOOL',
    Detail: 'Every 10000 ALPA staked earns approximately 1000 WOOL per day.',
    Detail2: 'A maximum of 50,000 ALPA can be staked.',
  },
  Traits: {
    accent_color: 'accent color',
    base_color: 'base color',
    ears: 'ears',
    eye_color: 'eye color',
    eye_shape: 'eye shape',
    hairs: 'hairs',
    highlight_color: 'highlight color',
    mouth: 'mouth',
    pattern: 'pattern',
    tail: 'tail',
    unknown1: 'unknown1',
    unknown2: 'unknown2',
  },
  Boost: {
    GensisAlpaca: 'Gensis Alpaca',
    EnergyDrinks: 'Energy Drinks',
    Green: 'Green Bull',
    Blue: 'Blue Bull',
    Red: 'Red Bull',
  },
  Airdrop: {
    ForWhitelistedPlayers: 'For Whitelisted Players',
    ForOGs: 'For OGs',
    WhiteClaimAlpaca:
      'Whitelisted addresses can claim 1 Alpaca for FREE on a FCFS basis.',
    ClaimAlpacaBtn: 'Claim Free Alpaca',
    WhiteClaimWool:
      'Claim 500 WOOL for FREE. WOOL can be used to exchange for high grade generation 0 Alpacas & limited edition Alpacas here',
    ClaimWoolBtn: 'Claim 500 WOOL',
    OGClaimAlpaca:
      'All ALPA and Alpaca NFT holders on Ethereum on November 29th, 8pm PST will be guaranteed to claim 2 FREE Gen 0 Alpaca',
    NoAlpaca: 'All Alpacas have been claimed',
  },
  SelectScarf: {
    SelectScarf: 'Choose an alpaca to put on',
    Activity1:
      'This is a Christmas special farm that opens from 2020/12/21 3:00 UTC to 2021/1/1 23:59 UTC.',
    Activity2:
      'You can stake in at most ONE Christmas Scarf to farm ${num} worth of ALPA reward.',
  },
};
